// 本页面基于antdv构建
<template>
  <div id="user-page">
    <div class="page-header">
      <a-button type="link" icon="left" @click="goBack">返回</a-button>
    </div>
    <template>
      <div class="card-box">
        <div class="user-name">
          <div>
            {{ currentStaff.name }}
            <span class="tel">{{ currentStaff.mobile }}</span>
          </div>
          <template v-if="isManager">
            <a-button
              type="link"
              size="small"
              @click="
                () => {
                  staffShow = true
                }
              "
              >选择员工</a-button
            >
          </template>
        </div>
      </div>
      <div class="card-box">
        <a-card title="统计周期">
          <template v-for="(item, index) in periods">
            <a-card-grid
              :key="item.value"
              class="card-col"
              :class="{ current: currentPeriodIndex === index && !customTime }"
              @click="changePeriod(index)"
              >{{ item.label }}</a-card-grid
            >
          </template>
        </a-card>
        <template>
          <a-config-provider :locale="locale">
            <div class="time_box">
              <div class="time_start">
                <a-date-picker
                  v-model="startTime"
                  placeholder="选择时间"
                  @change="onChange"
                >
                  <span>{{ startTime ? dateFormat(startTime) : '开始' }}</span>
                </a-date-picker>
              </div>
              <div class="time_divide">~</div>
              <div class="time_end">
                <a-date-picker
                  v-model="endTime"
                  placeholder="选择时间"
                  @change="onChange"
                >
                  <span>{{ endTime ? dateFormat(endTime) : '结束' }}</span>
                </a-date-picker>
              </div>
              <div
                :class="{ time_btn: true, cur: customTime }"
                @click="setCustomTime"
              >
                {{ customTime ? '自定义' : '确定' }}
              </div>
            </div>
          </a-config-provider>
        </template>
      </div>
    </template>

    <template>
      <a-spin :spinning="dataLoading">
        <div class="card-box">
          <a-row :gutter="12">
            <a-col :span="12">
              <a-card
                title="客户数量"
                :bordered="false"
                @click="goCustomerList"
              >
                <p class="card-data">{{ customerNum }}</p>
              </a-card>
            </a-col>
            <a-col :span="12">
              <a-card title="沟通记录" :bordered="false" @click="goRecords(0)">
                <p class="card-data">{{ recordNum }}</p>
              </a-card>
            </a-col>
          </a-row>
          <a-row :gutter="12" class="card-row">
            <a-col :span="12">
              <a-card title="订单数量" :bordered="false" @click="goRecords(1)">
                <p class="card-data">{{ orderNum }}</p>
              </a-card>
            </a-col>
            <a-col :span="12">
              <a-card title="订单金额" :bordered="false" @click="goRecords(1)">
                <p class="card-data">{{ parseInt(orderAmount) }}</p>
              </a-card>
            </a-col>
          </a-row>
        </div>
      </a-spin>
    </template>

    <a-modal title="选择员工" v-model="staffShow" :footer="null">
      <a-card class="staffs-card">
        <template v-for="item in sellers">
          <a-card-grid
            class="card-col"
            :key="item.id"
            @click="changeStaff(item)"
            >{{ item.name }}</a-card-grid
          >
        </template>
      </a-card>
    </a-modal>
  </div>
</template>
<script>
import Customer from '../api/customer'
import Staff from '../api/staff'

import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')
const periods = [
  { value: 'today', label: '今天' },
  { value: 'this_week', label: '本周' },
  { value: 'this_month', label: '本月' },
  { value: 'all', label: '全部' }
]
export default {
  name: 'User',
  data () {
    return {
      moment,
      staffShow: false,
      sellers: [],
      currentStaff: {},
      dataLoading: true,
      customerNum: 0,
      recordNum: 0,
      orderNum: 0,
      orderAmount: 0,
      periods: [],
      currentPeriodIndex: 0,
      isManager: false,
      locale: zhCN,
      startTime: undefined,
      endTime: undefined,
      customTime: false
    }
  },
  created () {
    this.getStaff()
    this.getMystaffs()
    this.periods = periods
    this.getStatisticsData()
  },
  methods: {
    dateFormat (time) {
      return moment(time).format('YYYY/MM/DD')
    },
    onChange () {
      this.customTime = false
    },
    setCustomTime () {
      if (this.startTime || this.endTime) {
        this.customTime = true
        this.currentPeriodIndex = undefined

        this.getStatisticsData()
      } else {
        this.$message.error('请选择查询的时间')
      }
    },
    goCustomerList () {
      this.setFilterParams()
      this.$router.push({ name: 'home' })
    },
    goRecords (tradeIf) {
      if (this.customTime) {
        // 有自定义时间
        let _start = this.startTime ? this.startTime.format('YYYY-MM-DD') : ''
        let _end = this.endTime ? this.endTime.format('YYYY-MM-DD') : ''
        this.$store.dispatch('storeRecordsParams', {
          staff_id: this.currentStaff.id,
          start: _start,
          end: _end,
          trade_if: tradeIf
        })
      } else {
        this.$store.dispatch('storeRecordsParams', {
          staff_id: this.currentStaff.id,
          period: this.periods[this.currentPeriodIndex].value,
          trade_if: tradeIf
        })
      }
      this.$router.push({ name: 'records' })
    },
    changeStaff (staff) {
      this.currentStaff = staff
      this.dataLoading = true
      this.staffShow = false
      this.getStatisticsData()
    },
    changePeriod (index) {
      this.dataLoading = true
      this.currentPeriodIndex = index

      this.endTime = this.startTime = undefined
      this.customTime = false

      this.getStatisticsData()
    },
    getStaff () {
      Staff.get_staff().then(res => {
        if (res.data && res.data.code === 1) {
          this.currentStaff = res.data.data
          if (res.data.data.erp_role_id === 1) {
            this.isManager = true
            this.getSellers()
          }
        } else {
          this.$message.error(res.data.msg || '获取员工信息出错')
        }
      })
    },
    getMystaffs () {
      Staff.get_my_staffs().then(({ data }) => {
        if (data.data && data.data.length > 0) {
          this.isManager = true
          this.sellers = data.data
        }
      })
    },
    getSellers () {
      Customer.get_salesmen().then(res => {
        this.sellers = res.data.data
      })
    },
    getStatisticsData () {
      let _start = this.startTime ? this.startTime.format('YYYY-MM-DD') : ''
      let _end = this.endTime ? this.endTime.format('YYYY-MM-DD') : ''
      let _period =
        this.currentPeriodIndex !== undefined
          ? this.periods[this.currentPeriodIndex].value
          : ''
      let params = {
        staff_id: this.currentStaff.id,
        period: _period,
        start: _start,
        end: _end
      }
      Staff.get_staff_statistics(params).then(res => {
        if (res.data && res.data.code === 1) {
          let data = res.data.data
          this.customerNum = data.customer_num
          this.orderNum = data.order_num
          this.recordNum = data.record_num
          this.orderAmount = data.order_amount
          this.dataLoading = false
        } else {
          this.$message.error(res.data.msg || '获取统计数据失败')
        }
      })
    },
    setFilterParams () {
      if (this.customTime) {
        // 有自定义时间
        let _start = this.startTime ? this.startTime.format('YYYY-MM-DD') : ''
        let _end = this.endTime ? this.endTime.format('YYYY-MM-DD') : ''
        this.$store.dispatch('storeParams', {
          staff_id: this.currentStaff.id,
          end: _end,
          start: _start
        })
      } else {
        // 使用时段选择
        this.$store.dispatch('storeParams', {
          staff_id: this.currentStaff.id,
          period: this.periods[this.currentPeriodIndex].value
        })
      }
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss">
#user-page {
  min-height: 100vh;
  background-color: #ececec;

  .page-header {
    padding: 8px 12px 0;
  }

  .card-box {
    padding: 12px 12px 0;

    .ant-card-head {
      min-height: 30px;
      .ant-card-head-title {
        padding: 12px 0;
        text-align: center;
      }
    }
    .card-col {
      width: 25%;
      text-align: center;
      padding: 12px;
      &.current {
        background: #409eff;
        color: #fff;
      }
    }
    .user-name {
      padding: 12px;
      border: 1px solid #e8e8e8;
      background: #fff;
      font-size: 24px;
      display: flex;
      justify-content: space-around;
      align-items: baseline;

      .tel {
        font-size: 14px;
      }
    }
    .card-row {
      margin-top: 12px;
    }
    .card-data {
      text-align: center;
      font-size: 26px;
      margin-bottom: 0;
    }

    .time_box {
      margin: -1px 0 0 -1px;
      border: 1px solid #e8e8e8;
      height: 45px;
      line-height: 45px;
      background-color: #fff;
      display: flex;
      justify-content: space-between;

      .time_start,
      .time_end {
        width: 35%;
        text-align: center;
      }

      .time_btn {
        width: 25%;
        box-shadow: 1px 0 0 0 #e8e8e8, 0 0 0 0 #e8e8e8, 1px 0 0 0 #e8e8e8,
          1px 0 0 0 #e8e8e8 inset, 0 0 0 0 #e8e8e8 inset;
        text-align: center;
        &.cur {
          background-color: #409eff;
          color: #fff;
        }
      }
    }
  }
}
.staffs-card {
  .card-col {
    width: 50%;
    padding: 24px;
    text-align: center;
    font-size: 18px;
  }
}
</style>
